import { ResourceListItem } from './ResourceListItem';
import type { ResourceItemDto } from '@/lib/types/resources.types';

interface ResourceListProps {
  items: ResourceItemDto[];
  /** Called when the user wants to open an item. Caller resolves URL/download. */
  onOpenItem: (item: ResourceItemDto) => void;
}

/**
 * Single-column list of resource rows for the folder page (FR-158), in place
 * of the landing page's card grid.
 */
export function ResourceList({ items, onOpenItem }: ResourceListProps) {
  return (
    <ul className="flex flex-col gap-4">
      {items.map((item) => (
        <li key={item.id}>
          <ResourceListItem item={item} onOpen={() => onOpenItem(item)} />
        </li>
      ))}
    </ul>
  );
}
